import { render, staticRenderFns } from "./costExpensesPieTwo.vue?vue&type=template&id=48e46613&scoped=true"
import script from "./costExpensesPieTwo.vue?vue&type=script&lang=js"
export * from "./costExpensesPieTwo.vue?vue&type=script&lang=js"
import style0 from "./costExpensesPieTwo.vue?vue&type=style&index=0&id=48e46613&prod&lang=stylus&scoped=true"
import style1 from "./costExpensesPieTwo.vue?vue&type=style&index=1&id=48e46613&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e46613",
  null
  
)

export default component.exports